window.FibraxCore = window.FibraxCore || (() => {
  const formatMoney = (value, currency = 'MXN') => new Intl.NumberFormat('es-MX', {
    style: 'currency', currency, minimumFractionDigits: 2
  }).format(Number(value || 0));

  const showToast = (root, message, isError = false) => {
    const toast = root?.querySelector('[data-fx-toast]') || document.querySelector('[data-fx-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.style.background = isError ? '#b42318' : '#101827';
    toast.classList.add('is-visible');
    clearTimeout(toast._fxTimer);
    toast._fxTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };

  const setBusy = (button, busy, label) => {
    if (!button) return;
    if (busy) {
      button.dataset.fxOriginalLabel = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span class="fx-spinner" aria-hidden="true"></span> Agregando';
    } else {
      button.disabled = false;
      button.innerHTML = label || button.dataset.fxOriginalLabel || 'Agregar al carrito';
    }
  };

  const addToCart = async ({ variantId, quantity = 1, unitLabel = '', properties = {}, root, button }) => {
    const id = Number(variantId || 0);
    const qty = Math.max(1, Math.round(Number(quantity || 1)));
    if (!id) {
      showToast(root, 'Configura el producto correspondiente en el editor del tema.', true);
      return false;
    }
    setBusy(button, true);
    let cartEventTools = null;
    let deferredEvent = null;

    try {
      cartEventTools = await import('@shopify/events').catch(() => null);
      if (cartEventTools?.CartLinesUpdateEvent) {
        deferredEvent = cartEventTools.CartLinesUpdateEvent.createPromise();
        (button || root || document).dispatchEvent(new cartEventTools.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(id), quantity: qty }],
          promise: deferredEvent.promise
        }));
      }

      const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);
      const requestBody = {
        items: [{ id, quantity: qty, properties }],
        sections_url: window.location.pathname
      };
      if (sectionIds.length) requestBody.sections = sectionIds.join(',');

      const shopRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(requestBody)
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload.description || payload.message || 'No fue posible agregar el producto.');
      }

      if (deferredEvent && cartEventTools?.CartLinesUpdateEvent) {
        const cartResponse = await fetch(`${shopRoot}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        const ajaxCart = await cartResponse.json();
        deferredEvent.resolve({
          cart: cartEventTools.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
          detail: {
            sections: payload.sections || {},
            items: payload.items || [],
            source: 'fibrax-tools',
            sourceId: root?.id || '',
            itemCount: qty
          }
        });
      }

      const singular = unitLabel || 'unidad';
      const pluralLabel = singular === 'caja' ? 'cajas' : singular === 'saco' ? 'sacos' : `${singular}es`;
      const displayUnit = qty === 1 ? singular : pluralLabel;
      const addedWord = singular === 'caja' ? (qty === 1 ? 'agregada' : 'agregadas') : (qty === 1 ? 'agregado' : 'agregados');
      showToast(root, `${qty.toLocaleString('es-MX')} ${displayUnit} ${addedWord} al carrito.`);
      return true;
    } catch (error) {
      deferredEvent?.reject?.(error);
      showToast(root, error.message || 'No fue posible agregar el producto.', true);
      return false;
    } finally {
      setBusy(button, false);
    }
  };

  const withQuery = (url, params) => {
    try {
      const target = new URL(url || '/pages/contacto', window.location.origin);
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') target.searchParams.set(key, value);
      });
      return target.toString();
    } catch (_) {
      return url || '/pages/contacto';
    }
  };

  return { formatMoney, showToast, addToCart, withQuery };
})();
